module.exports = __webpack_public_path__ + "img/get_your_shot_together.97ac4fa1.jpg";